import React, {Fragment} from "react";
import Year from "#app/pages/IncomeAndExpenses/components/BaseOperationList/List/Year";
import Month from "#app/pages/IncomeAndExpenses/components/BaseOperationList/List/Month";
import Date from "#app/pages/IncomeAndExpenses/components/BaseOperationList/List/Date";
import Item from "#app/pages/IncomeAndExpenses/components/BaseOperationList/List/Item";

export const TableContent = ({
                          preparedActives,
                          currencyId,
                          subcategoryType,
                          customTypeId,
                          types,
                          tags,
                          subcategories,
                          isNotVisibleSum,
                          handleClick,
                          detachCallback
                      }) => {

    return preparedActives.map((year, yIdx) => (
        <Fragment key={`year-${yIdx}`}>
            <Year year={year} currencyId={currencyId}>
                {year.months.map((month, mIdx) => (
                    <Fragment key={`month-${mIdx}`}>
                        <Month year={year} month={month} currencyId={currencyId}>
                            {month.dates.map((date, dIdx) => {
                                return <Date
                                    key={`date-${dIdx}`}
                                    year={year}
                                    month={month}
                                    date={date}
                                    currencyId={currencyId}
                                >
                                    {date.items.map((item) => (
                                        <Item
                                            key={item.innerKey}
                                            subcategoryType={subcategoryType}
                                            customTypeId={customTypeId}
                                            types={types}
                                            tags={tags}
                                            subcategories={subcategories}
                                            item={item}
                                            year={year}
                                            month={month}
                                            date={date}
                                            isNotVisibleSum={isNotVisibleSum}
                                            currencyId={currencyId}
                                            handleClick={handleClick}
                                            detachCallback={detachCallback}
                                        />
                                    ))}
                                </Date>
                            })}
                        </Month>
                    </Fragment>
                ))}
            </Year>
        </Fragment>
    ));
};
